var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-circle-timer"},[_c('div',{staticClass:"ui-circle-timer__text"},[_vm._t("default")],2),(_vm.value)?_c('svg',[_c('circle',{style:(_vm.style),attrs:{"r":"20","cx":"22","cy":"22"}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }